import React from "react";
import PrintEducationPage from "./PrintEducationPage";
import CvHeader from "./CvHeader";
import ExperienceItem from "./Experiences";
import LanguageItem from "./Languages";
import PrintRoles from "./PrintRoles";
import PrintSkillsPage from "./PrintSkillsPage";
import PrintHobbiesPage from "./PrintHobbiesPage";
import PrintFooter from "./PrintFooter";
import getProfilePictureSource from "../../genericFunctions/getProfilePictureSource";
import getDisplayContactInfo from "../../genericFunctions/getDisplayContactInfo";
import getProfileLabel from "../../genericFunctions/getProfileLabel";

const PrintConsultantPage = (props) => {
  const printableId = props.printableId;
  const anonymousProfile = props.anonymousProfile;
  const managerResume = props.managerResume;
  const language = props.language;
  const label = (key) => getProfileLabel(language, key);
  const {
    languages,
    experiences,
    skills,
    hobbies,
    educations,
    presentation,
    managerInfo,
    consultantEmail,
    consultantPhoneNo,
    consultantFirstname,
    consultantLastName,
    consultantProfilePic,
    consultantTitle,
    roles
  } = props;

  const { displayEmail, displayPhone } = getDisplayContactInfo(
    anonymousProfile,
    managerResume,
    consultantEmail,
    managerInfo.email,
    consultantPhoneNo,
    managerInfo.phone
  );

  return (
    <div id={printableId}>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td>
              <CvHeader
                profilePictureSrc={getProfilePictureSource(
                  anonymousProfile,
                  consultantProfilePic
                )}
                consultantTitle={consultantTitle}
                email={displayEmail}
                phone={displayPhone}
                managerInfoText={
                  managerResume ? label("managerContactInfo") : ""
                }
                displayName={
                  anonymousProfile
                    ? label("anonymous")
                    : `${consultantFirstname} ${consultantLastName}`
                }
              />
              <div
                style={{
                  display: "flex",
                  backgroundColor: "white",
                  padding: "20px 0px 20px 20px",
                }}
              >
                <div
                  style={{
                    width: "25%",
                  }}
                >
                  <PrintRoles roles={roles} language={language} />
                  <PrintSkillsPage skills={skills} language={language} />
                  <PrintEducationPage
                    educations={educations}
                    language={language}
                  />

                  <div
                    className="print-font"
                    style={{
                      paddingRight: "15px",
                      marginTop: "40px",
                      maxWidth: "100%",
                    }}
                  >
                    <h3 style={{ marginBottom: "10px", background: "#ffffff" }}>
                      {label("languages")}
                      <div className="print-border"></div>
                    </h3>
                    <LanguageItem languages={languages} language={language} />
                  </div>

                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <PrintHobbiesPage hobbies={hobbies} language={language} />
                  </div>
                </div>
                <div
                  style={{
                    width: "75%",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    borderRight: "1px solid #e1e1e1",
                  }}
                >
                  <div style={{ margin: "0px 0px" }}>
                    <div>
                      <h3
                        className="print-font"
                        style={{ marginBottom: "10px", background: "#ffffff" }}
                      >
                        {label("presentation")}
                        <div className="print-border"></div>
                      </h3>
                      <p className="print-font" style={{whiteSpace: "pre-wrap", fontSize: "14pt" }}>
                        {presentation}
                      </p>
                    </div>

                    <h3
                      className="print-font"
                      style={{ margin: "0px", background: "#ffffff" }}
                    >
                      {label("experiences")}
                      <div className="print-border"></div>
                    </h3>
                    <ExperienceItem
                      experiences={experiences}
                      language={language}
                    />
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <div className="footer-space">&nbsp;</div>
            </td>
          </tr>
        </tfoot>
      </table>

      <PrintFooter
        className="footer"
        email={displayEmail}
        phone={displayPhone}
      />
    </div>
  );
};
export default PrintConsultantPage;
